// extracted by mini-css-extract-plugin
export default {"spinner-loader":"SpinnerLoader_spinner-loader__a592V"};